import { FC } from 'react';

import Button from 'molecules/Button';
import Image from 'molecules/Image';
import RichText from 'molecules/RichText';

import { hasArrayValues } from 'utils/array/arrays';

const CompanyCard: FC<CompanyCardReference> = ({
  companyName,
  stats,
  description,
  descriptionRichText,
  logo,
  button,
}) => {
  const descriptionContent = descriptionRichText || description;

  return (
    <div className="flex items-center rounded-lg border-[1.5px] border-solid border-primary-200 bg-primary-50 px-6 py-8">
      <div className="flex flex-col gap-4">
        {logo?.url && (
          <Image url={logo.url} alt={logo?.alt || 'company logo'} {...logo} className="h-10 w-fit max-w-full" />
        )}
        <div className="flex flex-col gap-4">
          {hasArrayValues(stats) &&
            stats.map(stat => (
              <div key={stat.key} className="flex flex-col gap-2">
                <span className="font-spaceGrotesk text-lg font-bold text-gray-900">{stat.key}</span>
                <span className="font-spaceGrotesk text-md text-gray-700">{stat.value}</span>
              </div>
            ))}
        </div>
        <div className="flex flex-col gap-4">
          {descriptionContent && (
            <h2 className="font-spaceGrotesk text-xl font-bold text-heading">About {companyName}</h2>
          )}

          {descriptionContent && (
            <RichText text={descriptionContent} className="font-spaceGrotesk text-md text-gray-700" />
          )}

          {button?.label && button?.url && (
            <Button
              {...button}
              className="!w-full !bg-buttonLightGradient !text-gray-900"
              href={button.url}
              label={button.label}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyCard;
